import { ref } from "vue";

/**
 * Whether the system is mid-update.
 *
 * Raised by the API client when a call is refused with the maintenance code,
 * and cleared by reloading the page once the API answers normally again — the
 * reload also picks up the new release's screens, which a page loaded before
 * the deploy would otherwise keep running.
 */
export const updating = ref(false);

let timer = null;

const check = async () => {
  try {
    // Plain fetch, not the API client, so a still-refused check does not
    // re-enter the interceptor that raised this in the first place.
    const response = await fetch("/api/v1/", { headers: { Accept: "application/json" }, cache: "no-store" });

    if (response.status !== 503) {
      window.location.reload();
      return;
    }
  } catch {
    // The server restarting can drop the connection; keep waiting.
  }

  timer = setTimeout(check, 5000);
};

export const markUpdating = () => {
  if (updating.value) return;

  updating.value = true;
  timer = setTimeout(check, 5000);
};

export const isMaintenance = (error) =>
  error?.response?.status === 503 && error.response.data?.errors?.code === "MAINTENANCE";
